import React, { useState } from 'react';
import { MDBDataTable } from 'mdbreact';
import { withNamespaces } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import EntriesSelector from '../tableServerPagination/entriesSelector';
import PaginationButtons from '../tableServerPagination/paginationButtons';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import './PlcSafetyCauseList.scss';

const STATUS_OPTIONS = ['ACTIVE', 'REARMED', 'RESOLVED'];

const PlcSafetyCauseList = function (props) {
  const [size, setSize] = useState(20);
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('');

  const user = JSON.parse(localStorage.getItem('authUser'));

  const changeStatus = (event) => {
    const value = event.target.value;
    setStatus(value);
    setPage(1);
    props.getPlcSafetyCauses(user, size, 1, value || undefined);
  };

  return (
    <React.Fragment>
      <Row className="plc-safety-cause-filters align-items-center border-bottom pb-3 mb-3">
        <Col md="auto" className="d-flex align-items-center">
          <EntriesSelector
            label={props.t('Mostrar')}
            size={size}
            setSize={setSize}
            setPage={setPage}
            getEntries={props.getPlcSafetyCauses}
            extraArgs={[status || undefined]}
          />
        </Col>
        <Col md="auto" className="d-flex align-items-center">
          <label className="mr-2 mb-0">{props.t('Estado')}</label>
          <select className="custom-select custom-select-sm w-auto" value={status} onChange={changeStatus}>
            <option value="">{props.t('Todos')}</option>
            {STATUS_OPTIONS.map((s) => (
              <option key={s} value={s}>
                {props.t(s)}
              </option>
            ))}
          </select>
        </Col>
      </Row>
      <div className="plc-safety-cause-table">
        <MDBDataTable
          responsive
          striped
          bordered
          data={props.causeList}
          info={false}
          paginationLabel={[props.t('Previous'), props.t('Next')]}
          entriesLabel={props.t('Mostrar')}
          noRecordsFoundLabel={props.t('No matching records found')}
          infoLabel={[props.t('Showing'), props.t('to'), props.t('of'), props.t('entries')]}
          searchLabel={props.t('Search')}
          paging={false}
        />
      </div>
      <PaginationButtons
        size={size}
        page={page}
        setPage={setPage}
        totalPages={props.totalPages}
        getEntries={props.getPlcSafetyCauses}
        extraArgs={[status || undefined]}
        nextBtnLabel={props.t('Next')}
        prevBtnLabel={props.t('Previous')}
        t={props.t}
      />
    </React.Fragment>
  );
};

export default withNamespaces()(PlcSafetyCauseList);
